export default "__VITE_ASSET__DTriStG$__"